import { APITypesV1 } from "@cur8/api-client";
import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";

export function useRoomAssignedPatientQuery({
  roomId,
}: {
  roomId: string | undefined;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(roomId),
    queryFn: roomId ? queryFn(apiClient, roomId) : skipToken,
  });
}

const queryKey = (roomId: string | undefined) =>
  ["room-assigned-patient", roomId] as const;

const queryFn =
  (apiClient: APIClient, roomId: string) =>
  async (): Promise<APITypesV1.AssignedPatient | undefined | null> => {
    const roomDTO = await apiClient.schedule.fetchRoom({ roomId }).result;
    return roomDTO.assignedPatient;
  };
